import type { FeatureModule } from '@/shell/registry/types'

export default {
  code: 'knowledge',
  title: '在线知识',
  /** 与服务端 registry 对齐：知识依赖云空间（文件入库）与任务（入库任务列表） */
  dependsOn: ['cloudspace', 'tasks'],
  provides: {
    /** 云空间内嵌知识面板（我的知识/企业知识） */
    'knowledge.panel': () => import('./KnowledgePanel.vue'),
    /** 云空间文件面板内嵌的入库任务列表 */
    'knowledge.jobs': () => import('./KnowledgeJobs.vue'),
    /** 工作台/云空间内嵌的资料接收 */
    'knowledge.material-receipt': () => import('./MaterialReceipt.vue'),
    /** 需求详情/评审内嵌的知识来源抽屉 */
    'knowledge.source-drawer': () => import('./KnowledgeSourceDrawer.vue'),
    /** 方案知识页内嵌的当前知识正文 */
    'knowledge.current': () => import('./CurrentKnowledge.vue'),
  },
  routes: [
    { path: '/knowledge', name: 'knowledge', component: () => import('./KnowledgeView.vue'), meta: { title: '在线知识' } },
  ],
} satisfies FeatureModule
